export default __webpack_public_path__ + "static/media/English-Yellow.bc5b741e.jpg";